<div class="steps">
  <div
    *ngFor="let st of steps; let i = index"
    class="step"
    [ngClass]="{ 'step--done': step > i + 1, 'step--active': step === i + 1 }"
  >
    <i class="material-icons step__icon">
      {{ st.icon }}
    </i>

    <div class="step__name">
      <ng-container [ngSwitch]="i + 1">
        <ng-container *ngSwitchCase="1" i18n="First step caption in checkout|On the cart view">View</ng-container>
        <ng-container *ngSwitchCase="2" i18n="Second step caption in checkout|On the cart view"
          >Order info</ng-container
        >
        <ng-container *ngSwitchCase="3" i18n="Third step caption in checkout|On the cart view"
          >Card details</ng-container
        >
        <ng-container *ngSwitchCase="4" i18n="Last step caption in checkout|On the cart view">Booked</ng-container>
      </ng-container>
    </div>
  </div>
</div>
